export default "__VITE_ASSET__5c5315cd__"